import { AxiosInstance } from 'axios';
import { ShiftCountRepository } from '@/model/repository/shift/ShiftCountRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): ShiftCountRepository => ({
    index(payload) {
      const { year, month, facilityIds, firstDayOfTheMonth } = payload;
      const facilityIdParam = facilityIds.map((facilityId) => `facilityIds[]=${facilityId}`).join('&');
      return Repository.get(
        `${resource}/${Number(year)}/${Number(
          month
        )}/count?${facilityIdParam}&firstDayOfTheMonth=${firstDayOfTheMonth}`,
        { data: { errorHandle: false } }
      );
    },
  });
